import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { PopupMessageWrapper } from "./PopupMessageWrapper";
import { useDataContext } from "../Context/useDataContext";
import { useLSStates } from "../Hooks/useLSStates";
import { useNavigate } from "react-router-dom";

interface RoundCompleteFollowUpProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    newHoleSettings: (newHole: number) => void;
    preview?: boolean;
}

export const RoundCompleteFollowUp = ({ open, setOpen, newHoleSettings, preview = false }: RoundCompleteFollowUpProps) => {

    const navigate = useNavigate();
    const { setScoreLock } = useLSStates();
    const { eventData, currentRound } = useDataContext();

    const handleConfirm = async () => {
        setOpen(false);
        if (!preview) navigate('/login/');
    };

    const handleDecline = () => {
        setOpen(false);
        if (!preview) setScoreLock(true);
    };

    const hasMoreRounds = (eventData?.totalRounds ?? 2) > (currentRound ?? 1);

    return (
        <PopupMessageWrapper open={open}>
            {hasMoreRounds ? (
                <Stack direction="column" spacing={2} alignItems="center">
                    <Typography variant="h6" sx={{ color: 'sepia.dark', fontWeight: 700 }}>Round Complete</Typography>
                    <Typography variant="body1" sx={{ color: 'sepia.main', textAlign: 'center' }}>This round is complete. Do you want to start the next round?</Typography>
                    <Button variant="contained" onClick={handleConfirm} sx={{ backgroundColor: 'primary.light', color: 'white', '&:hover': { backgroundColor: 'primary.main' } }}>Yes, bring it on!</Button>
                    <Button variant="contained" onClick={handleDecline} sx={{ backgroundColor: 'sepia.extraLight', color: 'sepia.dark', '&:hover': { backgroundColor: 'sepia.light', color: 'white' } }}>Not yet</Button>
                </Stack>
            ) : (
                <Stack direction="column" spacing={2} alignItems="center">
                    <Typography variant="h6" sx={{ color: 'sepia.dark', fontWeight: 700 }}>Round Complete</Typography>
                    <Typography variant="body1" sx={{ color: 'sepia.main' }}>This round is complete.</Typography>
                    <Button variant="contained" onClick={handleDecline} sx={{ backgroundColor: 'sepia.extraLight', color: 'sepia.dark', '&:hover': { backgroundColor: 'sepia.light', color: 'white' } }}>Return for results</Button>
                </Stack>
            )}
        </PopupMessageWrapper>
    );
};
